import { render, staticRenderFns } from "./ScoreCard.vue?vue&type=template&id=8a6e3b8c&scoped=true&v-if=this.scoreData&"
import script from "./ScoreCard.vue?vue&type=script&lang=js&"
export * from "./ScoreCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6e3b8c",
  null
  
)

export default component.exports